export default "__VITE_ASSET__DRo$DwhB__"